import { render, staticRenderFns } from "./RegistrationFormCompany.vue?vue&type=template&id=18897fc8&scoped=true&"
import script from "./RegistrationFormCompany.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18897fc8",
  null
  
)

export default component.exports